import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import TransactionForm from './TransactionForm'
import { Transaction } from '../../types/Transaction'

interface TransactionModalProps {
  open: boolean
  onClose: () => void
  onSuccess: () => void
  transaction?: Transaction | null // ✅ now define it here
  defaultDate?: string
  submitOverride?: (payload: Record<string, unknown>) => Promise<void>
  disableDateEdit?: boolean
  disablePaymentEdit?: boolean
}

const TransactionModal: React.FC<TransactionModalProps> = ({
  open,
  onClose,
  onSuccess,
  transaction,
  defaultDate,
  submitOverride,
  disableDateEdit,
  disablePaymentEdit,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {transaction ? 'Edit Transaction' : 'Add Transaction'}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <TransactionForm
          transaction={transaction}
          onSuccess={onSuccess}
          defaultDate={defaultDate}
          submitOverride={submitOverride}
          disableDateEdit={disableDateEdit}
          disablePaymentEdit={disablePaymentEdit}
        />
      </DialogContent>
    </Dialog>
  )
}

export default TransactionModal
